import { SubscriptionSeatTypes } from "@safetyculture/s12-apis-connect-web/s12/common/seat_types_pb";
import { ComponentType } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/components_pb";
import {
  ChargePolicy,
  ProrationPolicy,
} from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/subscriptions_pb";

export const upgradeProrationPolicyDisplayMapping = {
  [ProrationPolicy.PRORATED]: "Charge the prorated amount",
  [ProrationPolicy.FULL]: "Charge the full amount",
  [ProrationPolicy.NONE]: "Do not charge",
  [ProrationPolicy.UNSPECIFIED]: "Unspecified",
};

export const chargePolicyDisplayMapping = {
  [ChargePolicy.DELAY]: "Charge at the end of billing period",
  [ChargePolicy.IMMEDIATE]: "Charge now",
  [ChargePolicy.UNSPECIFIED]: "Unspecified",
};

export const downgradeProrationPolicyDisplayMapping = {
  [ProrationPolicy.FULL]: "Credit the full amount to the next billing",
  [ProrationPolicy.NONE]: "Do not credit",
  [ProrationPolicy.PRORATED]: "Credit the prorated amount to the next billing",
  [ProrationPolicy.UNSPECIFIED]: "Unspecified",
};

export const componentTypeDisplayMapping = {
  [ComponentType.FREE_SEAT]: "Free Seat",
  [ComponentType.FULL_SEAT]: "Full Seat",
  [ComponentType.LITE_SEAT]: "Lite Seat",
  [ComponentType.UNSPECIFIED]: "Unspecified",
  [ComponentType.SENSOR_UNIT]: "Sensor",
  [ComponentType.DISCOUNT]: "Discount",
  [ComponentType.ENTERPRISE_PACKAGE]: "Enterprise Package",
};

export const subscriptionSeatTypeDisplayMapping = {
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_COLLABORATOR]: "Free Seat",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_LITE]: "Lite Seat",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_PREMIUM]: "Full Seat",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_SERVICE_USER]: "",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_SUPPORT]: "Support",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_UNSPECIFIED]: "Unspecified",
};
